import React, {useMemo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import AdminNavSegmented from "components/admin/nav-segmented"
import {Contact} from "models"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import propTypesExact from "prop-types-exact"
import Routes from "shared/routes"
import useI18n from "i18n-on-steroids/build/src/use-i18n.js"

export default memo(shapeComponent(class RoutesAdminContactsNav extends ShapeComponent {
  static defaultProps = {
    testID: undefined
  }

  static propTypes = propTypesExact({
    active: PropTypes.string.isRequired,
    contact: PropTypes.instanceOf(Contact).isRequired,
    style: PropTypes.object,
    testID: PropTypes.string
  })

  setup() {
    const {locale, t} = useI18n({namespace: "js.routes.admin.contacts.nav"})
    const {contact} = this.p

    this.buttons = useMemo(
      () => [
        {
          value: "general",
          label: t(".general"),
          to: Routes.adminContactPath(contact.id())
        },
        {
          value: "dialogue",
          label: Contact.humanAttributeName("dialogues"),
          to: Routes.adminContactDialoguePath(contact.id())
        },
        {
          value: "emails",
          label: t(".emails"),
          to: Routes.adminContactEmailsPath(contact.id())
        },
        {
          value: "phone-numbers",
          label: t(".phone_numbers"),
          to: Routes.adminContactPhoneNumbersPath(contact.id())
        },
        {
          value: "contact-points",
          label: `${Contact.humanAttributeName("contactPoints")} (${contact.contactPointsCount()})`,
          to: Routes.adminContactContactPointsPath(contact.id())
        }
      ],
      [locale]
    )
  }

  render() {
    const {buttons} = this.tt
    const {active, className, contact, ...restProps} = this.props

    return (
      <AdminNavSegmented
        active={active}
        buttons={buttons}
        dataSet={{class: className, component: "admin/contacts/nav"}}
        {...restProps}
      />
    )
  }
}))
